module.exports = __webpack_public_path__ + "static/Exrates-2f03c25ec0f940e52c2ebb4241f35737.png";